"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var spacingInPx = {
  padding: {
    top: 8,
    right: 42,
    bottom: 8,
    left: 42
  }
};

var buildFooterContainerStyles = function buildFooterContainerStyles(_ref) {
  var _ref$theme = _ref.theme,
      typography = _ref$theme.typography,
      palette = _ref$theme.palette;
  return (0, _styledComponents.css)(["padding:", " ", " ", " ", ";background-color:", ";text-align:center;"], typography.pxToRem(spacingInPx.padding.top), typography.pxToRem(spacingInPx.padding.right), typography.pxToRem(spacingInPx.padding.bottom), typography.pxToRem(spacingInPx.padding.left), palette.grey[200]);
};

var ModalFooter = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "ModalFooter"
})(["", ""], buildFooterContainerStyles);

ModalFooter.defaultProps = {};
var _default = ModalFooter;
exports["default"] = _default;